import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import { POPOVER_MENU_ITEMS } from '../../../constants';
import handleRolesOptions from './handleRolesOptions';

const {
  ROLE,
  RELATIONSHIP,
  EMAIL_OR_PHONE,
  PHONE_NUMBER,
  EMAIL,
} = PROFILE_FIELDS_TYPES;
const CHANGE_ROLE_POPUP_FIELDS = [ROLE];
const INVITE_ROLE_POPUP_FIELDS = [ROLE, RELATIONSHIP, EMAIL_OR_PHONE];
const INVITE_PATIENT_POPUP_FIELDS = [ROLE, PHONE_NUMBER, EMAIL];

export default (
  handlers,
  actionType,
  user,
  formatMessage,
  additionalParams,
) => {
  const { patientInvite, usePatientFields } = additionalParams;

  if (patientInvite) {
    const handler = usePatientFields
      ? POPOVER_MENU_ITEMS.INVITE_PATIENT
      : POPOVER_MENU_ITEMS.INVITE_MEMBER;
    const fields = usePatientFields
      ? INVITE_PATIENT_POPUP_FIELDS
      : INVITE_ROLE_POPUP_FIELDS;

    return {
      title: formatMessage({ id: 'dialog.common.invitePerson' }),
      submitBtnText: formatMessage({ id: 'common.invite' }),
      description: formatMessage({
        id: 'circles.invites.invitePerson',
      }),
      fields,
      onSubmit: handlers[handler],
      validateFields: usePatientFields ? [ROLE] : fields,
    };
  }

  if (actionType === POPOVER_MENU_ITEMS.CHANGE_ROLE) {
    return {
      title: formatMessage({ id: 'common.changeRole' }),
      description: formatMessage({
        id: 'circles.invites.makeChangeRoleDescription',
      }),
      initialData: user,
      fields: CHANGE_ROLE_POPUP_FIELDS,
      onSubmit: handlers[POPOVER_MENU_ITEMS.CHANGE_ROLE],
      handleFieldOptions: { [PROFILE_FIELDS_TYPES.ROLE]: handleRolesOptions },
    };
  }

  return {
    title: formatMessage({ id: 'circles.actions.inviteFamily' }),
    submitBtnText: formatMessage({ id: 'common.invite' }),
    description: formatMessage({
      id: 'circles.invites.makeInviteToFamilyCommon',
    }),
    fields: INVITE_ROLE_POPUP_FIELDS,
    onSubmit: handlers[POPOVER_MENU_ITEMS.INVITE_MEMBER],
  };
};



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/utils/getSimpleFormProps.js